import { Component } from 'react';

import ContentOuterBound from './common/atoms/ContentOuterBound';
import CasesHero from './common/molecules/CasesHero';
import ContentSpacer from './common/atoms/ContentSpacer';

import * as InternalPropTypes from '../constants/internal-types';
import * as Breakpoints from '../constants/breakpoints';
import {
  TypeBackgroundColorTypes,
  TypeSEOWeightTypes,
} from '../constants/cms-constants';
import SEOWeights from '../constants/cms/control-options/seo-weights';

const styles = {
  '&.cases-page-hero-component': {
    [Breakpoints.DesktopUp.mq]: {
      paddingTop: '154px',
    },
    [Breakpoints.Tablet.mq]: {
      paddingTop: '142px',
    },
    [Breakpoints.Mobile.mq]: {
      paddingTop: '112px',
    },
  },
};

type CasesPageHeroProps = {
  header?: InternalPropTypes.RichText;
  lightHeader?: InternalPropTypes.RichText;
  backgroundColor?: TypeBackgroundColorTypes;
  seoWeight?: TypeSEOWeightTypes;
};

class CasesPageHero extends Component<CasesPageHeroProps> {
  static defaultProps = {
    header: null,
    lightHeader: null,
    backgroundColor: null,
    seoWeight: SEOWeights.H1,
  };

  render() {
    const { header, lightHeader, backgroundColor, seoWeight } = this.props;
    const addStyle = backgroundColor ? { background: backgroundColor } : {};
    return (
      <div className="cases-page-hero-component" css={[styles, addStyle]}>
        <ContentOuterBound>
          <ContentSpacer>
            <CasesHero
              header={header}
              lightHeader={lightHeader}
              seoWeight={seoWeight}
            />
          </ContentSpacer>
        </ContentOuterBound>
      </div>
    );
  }
}

export default CasesPageHero;
